module.exports = __webpack_public_path__ + "static/media/es-roles.20f9a886.svg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/default/img/es-roles.svg
// module id = 638
// module chunks = 0 1